var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative d-flex align-center justify-center"
  }, [_c('div', {
    staticClass: "resize-box absolute-fill",
    class: {
      'as-override': !_vm.isPrimary && !_vm.isCropping,
      crop: _vm.isCropping,
      shadow: _vm.isCropping || _vm.indirectEdit && _vm.focused
    }
  }), _vm.canTransform ? [_vm._l([[-1, -1], [1, -1], [1, 1], [-1, 1]], function (_ref) {
    var x = _ref[0],
      y = _ref[1];
    return _c('div', {
      key: `${x}${y}`,
      staticClass: "btn-wrapper corner",
      class: {
        crop: _vm.isCropping
      },
      style: {
        left: x < 0 ? -_vm.btnOffset + 'px' : undefined,
        right: x > 0 ? -_vm.btnOffset + 'px' : undefined,
        top: y < 0 ? -_vm.btnOffset + 'px' : undefined,
        bottom: y > 0 ? -_vm.btnOffset + 'px' : undefined
      },
      on: {
        "mousedown": function (e) {
          return _vm.$emit('resize', e);
        },
        "touchstart": function (e) {
          return _vm.$emit('resize', e);
        }
      }
    }, [_c('v-btn', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      staticClass: "ma-3",
      staticStyle: {
        "cursor": "inherit"
      },
      style: {
        transform: `scale(${1 / _vm.scale})`
      },
      attrs: {
        "fab": "",
        "x-small": "",
        "color": "red",
        "disabled": _vm.disabled
      },
      nativeOn: {
        "contextmenu": function ($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    })], 1);
  }), _vm.isCropping ? [_c('div', {
    staticClass: "absolute-fill d-flex align-end",
    staticStyle: {
      "bottom": "0"
    },
    on: {
      "!click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('v-slider', {
    staticClass: "crop-rotate-slider",
    staticStyle: {
      "pointer-events": "auto"
    },
    attrs: {
      "min": "-45",
      "max": "45",
      "hide-details": "",
      "color": "transparent",
      "track-color": "transparent",
      "thumb-label": "always",
      "thumb-color": "deep-orange",
      "thumb-size": 44 / _vm.scale,
      "step": _vm.snap ? 5 : 1,
      "value": _vm.blob.crop.r > 45 ? _vm.blob.crop.r - 360 : _vm.blob.crop.r
    },
    on: {
      "input": function (v) {
        return _vm.blob.crop.r = v < 0 ? 360 + v : v;
      }
    },
    scopedSlots: _vm._u([{
      key: "thumb-label",
      fn: function () {
        return [_c('v-icon', {
          style: {
            transform: `scale(${1 / _vm.scale})`
          },
          attrs: {
            "color": "white"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiCropRotate)
          }
        })];
      },
      proxy: true
    }], null, false, 2930908597)
  })], 1)] : _c('div', {
    staticClass: "btn-wrapper",
    staticStyle: {
      "bottom": "-72px"
    },
    on: {
      "mousedown": function (e) {
        return _vm.$emit('rotate', e);
      },
      "touchstart": function (e) {
        return _vm.$emit('rotate', e);
      }
    }
  }, [_c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "ma-3",
    staticStyle: {
      "cursor": "inherit"
    },
    style: {
      transform: `scale(${1 / _vm.scale})`
    },
    attrs: {
      "fab": "",
      "small": "",
      "color": "red",
      "disabled": _vm.disabled
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiRotateRight)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom"
  }, [_vm._v("Drag to rotate")])], 1)], 1)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }